import React from 'react'
import IconBase from './IconBase'

const Planet = (props: React.ComponentProps<typeof IconBase>): React.ReactElement => {
  return (
    <IconBase viewBox="0 0 24 24" {...props}>
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <rect x="3.5" y="8.5" width="17" height="1" stroke="currentColor" strokeLinejoin="round" />
      <rect x="3.5" y="14.5" width="17" height="1" stroke="currentColor" strokeLinejoin="round" />
      <path
        d="M11.9999 3C11.9999 3 16 7.5 16 12C16 16.5 12 21 12 21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M12.0001 3C12.0001 3 8 7.5 8 12C8 16.5 12 21 12 21"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </IconBase>
  )
}

export default Planet
